import {CircularProgress, Backdrop, Typography} from "@mui/material";
import PropTypes from "prop-types";

export default function LoadingBackdrop(props){

    // const theme = useTheme();
    return (
         <Backdrop
              sx={{color: '#ffff', zIndex: (theme) => theme.zIndex.drawer + 1, }}
              open
              style={{"display": "block","textAlign": "center","margin": "auto", "background": "#070707",opacity: ".9" }}
          >
             <br/><br/>
            <CircularProgress color="inherit"/>
             {props.percent!=null && <Typography variant={"h3"}>{(props.percent*100).toFixed(2)}% ...complete</Typography>}<br/>
             {props.message!=null && <Typography variant={"h7"}>[{props.message}]</Typography>}
          </Backdrop>
    )
}

LoadingBackdrop.prototypes= {
    percent: PropTypes.number,
    message: PropTypes.string,
}